
    <div class="pv-toolbar">
      <button class="pv-btn" (click)="zoomOut()" title="Zoom out">−</button>
      <span class="pv-zoom-pct">{{ zoomPercent }}%</span>
      <button class="pv-btn" (click)="zoomIn()" title="Zoom in">+</button>
      <button class="pv-btn" (click)="reset()" title="Reset view">↺</button>
      <span class="pv-spacer"></span>
      <button class="pv-btn pv-newtab-btn" (click)="openInNewTab()" title="Open in new tab">⤢</button>
      <button class="pv-btn pv-close-btn" (click)="close()" title="Close">✕</button>
    </div>

    <div class="pv-canvas"
         (wheel)="onWheel($event)"
         (mousedown)="onMouseDown($event)"
         (mousemove)="onMouseMove($event)"
         (mouseup)="onMouseUp()"
         (mouseleave)="onMouseUp()"
         (touchstart)="onTouchStart($event)"
         (touchmove)="onTouchMove($event)"
         (touchend)="onTouchEnd()">
      <img [src]="data.url"
           [style.transform]="imgTransform"
           [style.cursor]="dragging ? 'grabbing' : 'grab'"
           (dblclick)="onDblClick()"
           draggable="false">
    </div>

    <div class="pv-hint">Scroll to zoom · Drag to pan · Double-click to reset</div>
  